import { Box, LinearProgress, Tooltip, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { DormitoryServicePath, ROOMS } from "utils/constants";
import {
  conditionDescription,
  occupancyRatio,
  ROOM_STATE_PRESENTATION,
  roomState,
  typeDescription,
} from "./roomHelpers";

const RoomTile = ({ room }) => {
  const fill = Math.round(occupancyRatio(room) * 100);
  const canManage = checkPermission(getPermissions(), permissions.canManageDormitoryRooms);
  const to = `/${DormitoryServicePath}${ROOMS}/${room.id}`;
  const state = room.state || roomState(room);
  const bg = ROOM_STATE_PRESENTATION[state].color;

  const tooltip = (
    <Box sx={{ minWidth: 180 }}>
      <Typography
        variant="subtitle2"
        sx={{ mb: 1 }}
      >
        Стая {room.roomNumber}
      </Typography>
      {typeDescription(room) ? <Typography variant="caption">Тип: {typeDescription(room)}</Typography> : null}
      {conditionDescription(room) ? (
        <Typography
          variant="caption"
          display="block"
        >
          Състояние: {conditionDescription(room)}
        </Typography>
      ) : null}
      {room.isUnusable ? (
        <Typography
          variant="caption"
          display="block"
        >
          Не може да се ползва
        </Typography>
      ) : null}
      <Typography
        variant="caption"
        display="block"
      >
        Капацитет: {room.capacity}
      </Typography>
      <Typography
        variant="caption"
        display="block"
      >
        Свободни места: {room.freeBeds ?? 0}
      </Typography>
      <Typography
        variant="caption"
        display="block"
      >
        Заети места: {room.occupiedBeds ?? 0}
      </Typography>
      {room.allocatedBeds > 0 && (
        <Typography variant="caption" display="block">
          Разпределени места: {room.allocatedBeds}
        </Typography>
      )}
      <LinearProgress
        variant="determinate"
        value={fill}
        sx={{ mt: 1, height: 6, borderRadius: 1 }}
      />
      <Typography
        variant="caption"
        display="block"
        align="right"
        sx={{ mt: 0.5 }}
      >
        {fill}%
      </Typography>
    </Box>
  );

  return (
    <Tooltip
      title={tooltip}
      placement="top"
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: "background.paper",
            color: "text.primary",
            border: 1,
            borderColor: "divider",
            boxShadow: 2,
            p: 1.5,
          },
        },
      }}
    >
      <Box
        component={canManage ? Link : "div"}
        to={canManage ? to : undefined}
        sx={{
          minWidth: 72,
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 1,
          py: 2,
          border: 1,
          borderColor: "divider",
          borderRadius: 1,
          bgcolor: bg,
          opacity: 0.85,
          color: "text.primary",
          textDecoration: "none",
          fontWeight: 500,
          fontSize: 14,
          "&:hover": { opacity: 1 },
        }}
      >
        {room.roomNumber}
      </Box>
    </Tooltip>
  );
};

export default RoomTile;
